/**
 * Fallback shown while a lazy-loaded route module is being fetched.
 *
 * Kept deliberately minimal — most route transitions resolve in a few
 * hundred ms on a warm cache, so a centred discreet label avoids
 * layout flash without imposing a spinner.
 */
export function RouteFallback() {
  return (
    <div
      className="flex min-h-screen items-center justify-center text-sm text-zinc-500 dark:text-zinc-400"
      role="status"
      aria-live="polite"
    >
      Chargement…
    </div>
  );
}
